// extracted by mini-css-extract-plugin
module.exports = {"badge":"qr","isRental":"qs","badgeWrapper":"qt","hide":"qu","roundedBadge":"qv","gridBadge":"qw","darkBackground":"qx"};